import { ButtonBase, styled as muiStyled } from '@mui/material'
import styled, { keyframes } from 'styled-components'

const extraOffsetForAnimation = '40px'

function calcAndReturnInNegativePxWithOffset(multiplier, variable = '0.8em') {
  return `calc(-1 * calc(calc(${variable} * ${multiplier}) - 0.04em) - calc(${extraOffsetForAnimation} * ${multiplier}))`
}

const rotate = keyframes`
  0%, 12.5%{
    transform: translateY(0em);
  }
  12.5%, 25% {
    transform: translateY(${calcAndReturnInNegativePxWithOffset(1, '0.8em')});
  }
  25%,37.5% {
    transform: translateY(${calcAndReturnInNegativePxWithOffset(2, '0.8em')});
  }
  37.5%,50%{
transform: translateY(${calcAndReturnInNegativePxWithOffset(3, '0.8em')});
  }
  50%,62.5% {
transform: translateY(${calcAndReturnInNegativePxWithOffset(4, '0.8em')});
  }
  62.5%,75% {
transform: translateY(${calcAndReturnInNegativePxWithOffset(5, '0.8em')});
  }
  75%,87.5% {
transform: translateY(${calcAndReturnInNegativePxWithOffset(6, '0.8em')});
  }
  87.5%, 100% {
transform: translateY(${calcAndReturnInNegativePxWithOffset(7, '0.8em')});
  }
  100% {
transform: translateY(${calcAndReturnInNegativePxWithOffset(8, '0.8em')});
  }
`

export const TextCarouselFrame = styled.div`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`
export const TextCarousel = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  width: 100%;
  text-align: center;
  font-size: 1em;
`

export const Pre = styled.div`
  flex-shrink: 0;
`

export const ChangeOuter = styled.div`
  height: 1em;
  overflow: hidden;
  font-size: 1.2em;
`

export const ChangeInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  animation: ${rotate} 27s cubic-bezier(0.1, 1.01, 0.62, 1) infinite;
`

export const TextCarouselElement = styled.div`
  display: block;
  font-weight: 700;
  color: #6655ab;
  height: 0.8em;
  display: flex;
  align-items: center;
`

export const BAPMainCardContainer = muiStyled('div')(
  ({ theme }) => `
    position: relative;
    display: flex;
    overflow: hidden;
    width: 100%;
    @media(min-width: 768px){
      height: 75vh;
      max-height: 840px;
    }
`,
)

export const BAPMainCardDetailsContainer = muiStyled('div')(
  ({ theme }) => `
    padding: 80px 30px;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    background-image:linear-gradient(91deg, white 25.5%, #00000000);
    z-index: 1;
    color: #000;
    backdrop-filter: blur(6.1px);
    font-size: 34px;
    display:flex;
    justify-content: flex-start;
    align-items: center;

    .layout-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap:50px;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }

    .card-details-text {
      font-size: 1em;
      width: 100%;
      font-weight: 600;
    }
    .card-details-text-secondary {
      font-size: 0.5em;
      width: 100%;
      font-weight: 400;
    }
    @media(min-width: 768px){
      font-size: 64px;
      .card-details-text-secondary {
        font-size: 0.3em;
      }
      .layout-container {
        gap: 120px;
      }
    }
`,
)

export const BAPMainCardActionButtonsContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
    @media(min-width: 768px){
      justify-content: flex-start;
      flex-direction: row;
      gap: 20px;
    }
`,
)

export const BAPMainCardActionButtonMain = muiStyled(ButtonBase)(
  ({ theme }) => `
// padding: 10px 38px 10px 40px;
border-radius: 20px;
letter-spacing: 2px;
text-align: center;
background-color: #6655AB;
color: white;
font-size: 0.4em;
max-width: 300px;
width: 100vw;
font-weight: 600;
padding: 14px 0px;
transition: all 400ms ${theme.transitions.easing.quickInOut};
&:hover {
  box-shadow: #6655AB 0px 5px 6px -3px;
  transform: translateY(-2px);
}
&:active {
  box-shadow: unset;
  transform: translateY(0px);
  background: #8879c3;

}
@media(min-width: 768px){
  font-size: 0.25em;
}
`,
)

export const BAPMainCardActionButtonSecondary = muiStyled(ButtonBase)(
  ({ theme }) => `
border-radius: 20px;
letter-spacing: 2px;
text-align: center;
background: transparent;
max-width: 300px;
width: 100vw;
border: 1px solid #6655AB;
color: #000;
font-size: 0.4em;
font-weight: 600;
padding: 14px 0px;
 &:hover {
  background-color: #cad2fe;
  border: 1px solid #cad2fe;
}
transition: all 400ms ${theme.transitions.easing.quickInOut};
@media(min-width: 768px){
  font-size: 0.25em;
}
`,
)

export const BAPMainCardImageContainer = muiStyled('div')(
  ({ theme }) => `
  width: 100%;
  height: 100%;
  position: absolute;
  display: none;
  top:0;
  left:0;
  @media(min-width: 768px){
    display: block;
  }

`,
)

export const BAPMainCardImage = muiStyled('img')(
  ({ theme }) => `
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    `,
)
